import { render, staticRenderFns } from "./TooltipsSite.vue?vue&type=template&id=764d3a74&scoped=true&lang=pug"
import script from "./TooltipsSite.vue?vue&type=script&lang=js"
export * from "./TooltipsSite.vue?vue&type=script&lang=js"
import style0 from "./TooltipsSite.vue?vue&type=style&index=0&id=764d3a74&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d3a74",
  null
  
)

export default component.exports